import NonCriticalError from '@/errors/NonCriticalError.js';

class ApiError extends NonCriticalError {
}

export default ApiError;
